export default __webpack_public_path__ + "static/media/bacon-sizzle.79a64cb6.mp3";